export function formatarData (data) {
  return (new Date(data)).toLocaleDateString('pt-br', { timeZone: 'UTC'});
}

export function formatarValor (valor, decimais = 2) {
  return valor.toLocaleString('pt-br', { maximumFractionDigits: decimais, minimumFractionDigits: decimais });
}

export function formataDataHora (data_atual) {
  let data = (new Date(data_atual)).toLocaleDateString('pt-br', { timeZone: 'America/Recife'});
  let hora = (new Date(data_atual)).toLocaleTimeString('pt-br', { timeZone: 'America/Recife'});
  let data_hora = data + ' - ' + hora;
  return data_hora;
}